import React, { useEffect } from 'react'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  $DCDangerColor,
  $DCDangerLightColor,
  $DCprimaryActiveColor,
  $DCprimaryLightColor,
  $DCSuccessColor,
  $DCSuccessLightColor,
  DcBreadcrumbs,
  DcFlexBox,
  DcOverlaySlider,
  DcTag,
  PixelDate,
  PixelPageContainer,
  PixelTable,
  Section,
  SectionContent,
} from 'pixel-base'

import { get } from 'utils/api-routes.util'

import UploadHistoryDetails from './UploadHistoryDetails'
export interface IInventoryUploads {
  file_name: string
  request_id: number
  created_by: string
  request_status: string
  warehouse_name: string
  total_products: string
  created_at: Date
}

const breadcrumbs = [
  {
    name: 'Warehouse List',
    link: '/inventory',
  },
  {
    name: 'Warehouse Inventory',
    link: '/inventory/warehouse-wise',
  },
  {
    name: 'Upload History',
    active: true,
  },
]
const InventoryUpload = () => {
  const [inventoryUploads, setInventoryUploads] = React.useState<
    IInventoryUploads[]
  >([])
  const [tableLoading, setTableLoader] = React.useState(true)
  const [showDetailModal, setShowDetailModal] = React.useState(false)
  const [requestId, setRequestId] = React.useState(null)

  const fetchInventoryUploads = () => {
    setTableLoader(true)
    get('/products/upload').subscribe((res: any) => {
      setInventoryUploads(res.response.data || [])
      setTableLoader(false)
    })
  }

  useEffect(() => {
    fetchInventoryUploads()
  }, [])

  const columns = [
    {
      dataKey: 'request_id',
      name: 'ID',
      sortable: true,
      selector: (row) => row.request_id,
    },
    {
      dataKey: 'file_name',
      name: 'File Name',
      sortable: true,
      selector: (row) => row.file_name,
    },
    {
      dataKey: 'warehouse_name',
      name: 'Warehouse',
      sortable: true,
      selector: (row) => row.warehouse_name || '--',
    },
    {
      dataKey: 'request_status',
      name: 'Status',
      sortable: true,
      selector: (row) =>
        row.request_status !== null ? (
          <DcTag
            textColor={$DCprimaryActiveColor}
            customBackgroundColor={$DCprimaryLightColor}
          >
            {row.request_status}
          </DcTag>
        ) : (
          '--'
        ),
    },
    {
      dataKey: 'update_type',
      name: 'Update Type',
      sortable: true,
      selector: (row) =>
        row.update_type !== null ? (
          <DcTag
            textColor={
              row.update_type == 'add' ? $DCSuccessColor : $DCDangerColor
            }
            customBackgroundColor={
              row.update_type == 'add'
                ? $DCSuccessLightColor
                : $DCDangerLightColor
            }
          >
            {row.update_type}
          </DcTag>
        ) : (
          '--'
        ),
    },
    {
      dataKey: 'created_by',
      name: 'Uploaded By',
      sortable: true,
      selector: (row) => row.created_by,
    },
    {
      dataKey: 'created_at',
      name: 'Created At',
      sortable: true,
      selector: (row) => (
        <PixelDate
          className="pixel-date"
          value={`${row.created_at} UTC`}
          format={'dateWithTime'}
        ></PixelDate>
      ),
    },
  ]
  return (
    <>
      <PixelPageContainer>
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px' }}>
            <DcFlexBox
              height="60px"
              style={{ fontSize: '16px', padding: '8px 0px' }}
            >
              <DcFlexBox
                justifyContent="space-between"
                alignItems="center"
                padding=".5rem 20px"
              >
                <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

                <ProfileSection />
              </DcFlexBox>
            </DcFlexBox>
          </SectionContent>
        </Section>
        <Section style={{ padding: '20px' }}>
          <SectionContent>
            <PixelTable
              columns={columns}
              data={inventoryUploads}
              isSearchable={true}
              progressPending={tableLoading}
              onRowClicked={(row) => {
                setShowDetailModal(true)
                setRequestId(row.request_id)
              }}
              fixedHeader
              fixedHeaderScrollHeight="calc(100vh - 172px)"
              highlightOnHover
              pointerOnHover
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>
      <DcOverlaySlider
        isOpen={showDetailModal}
        onClose={() => {
          setRequestId(null)
          setShowDetailModal(false)
        }}
        title="Details"
        width="70%"
        padding="10px"
      >
        {requestId !== null && (
          <UploadHistoryDetails
            requestId={requestId}
            setShowDetailModal={setShowDetailModal}
          />
        )}
      </DcOverlaySlider>
    </>
  )
}

export default InventoryUpload
